import cn from 'classnames';
import React from 'react';

import s from './WithGradientBorder.module.scss';

interface Props {
  children: JSX.Element | JSX.Element[];
  isSelected?: boolean;
  className?: string;
  onClick?: () => void;
}

export default function WithGradientBorder({
  children,
  isSelected,
  className,
  onClick,
}: Props): JSX.Element {
  return (
    <div
      onClick={onClick}
      className={cn(s.wrapper, { [s.selected]: isSelected }, className)}
    >
      {children}
    </div>
  );
}
